<template>
    <section :class="{ odd: isOdd}">
        <v-container>
            <v-row class="align-center justify-center my-2">
                <v-col cols="12" sm="6" md="8" class="text-center" :order="order[0]">
                    <h3>{{ $t('headline') }}</h3>
                    <h4 class="mt-3 mb-3">{{ transDisplayName }} <span v-if="project.project_standard">({{transProjectStandardName}})</span></h4>
                    <p class="pa-5">{{ transLongDescription }}</p>
                    <v-btn :href="projectPDF" rounded depressed color="primary">Details</v-btn>
                </v-col>
                <v-col cols="12" sm="6" md="4" :order="order[1]">
                    <div v-if="hasImages">
                        <v-img contain
                          :lazy-src="PlaceHolderLarge"
                          :src="project.project_images[0].image" />
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<i18n>
{
  "en": {
    "headline": "Supported Climate Project"

  },
  "de": {
    "headline": "Unterstütztes Klimaprojekt"

  }
}
</i18n>

<script>
import PlaceHolderLarge from '@/services/PlaceholderLarge';

export default {
  name: 'ProjectItem',
  data() {
    return {
      PlaceHolderLarge,
    };
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    hasImages() {
      if (this.project.project_images.length > 0) {
        return true;
      }
      return false;
    },
    isOdd() {
      return (this.index % 2) === 1;
    },
    order() {
      if (this.isOdd) {
        return ['first', 'last'];
      }

      return ['last', 'first'];
    },
    transProjectStandardName() {
      if (this.project.project_standard) {
        if (this.$i18n.locale === 'en') {
          return this.project.project_standard.name_en;
        }
        return this.project.project_standard.name;
      }
      return '';
    },
    transDisplayName() {
      if (this.$i18n.locale === 'en') {
        return this.project.display_name_en;
      }

      return this.project.display_name;
    },
    transLongDescription() {
      if (this.$i18n.locale === 'en') {
        return this.project.long_description_en;
      }

      return this.project.long_description;
    },
    projectPDF() {
      if (this.$i18n.locale === 'en') {
        return this.project.project_pdf_en;
      }

      return this.project.project_pdf;
    },
  },
};
</script>

<style lang="scss" scoped>
.odd {
  background-color: #011730;
  color: white;
}
</style>
